import { createContext, useContext, useReducer } from 'react';
import { reducer, initialState } from './reducer';

/**
 * Dispatch function for updating state
 * @param {{type: string, payload: string}} param0
 */
export const _dispatch = ({ type, payload }) => {
  // eslint-disable-next-line no-console
  console.error(`Unhandled action type: ${type} with payload: ${payload}`);
};

const AppContext = createContext(initialState);
const AppDispatchContext = createContext(_dispatch);

/**
 * Manages the app provider state.
 * @param {React.PropsWithChildren<{startingState?: typeof initialState}>} props
 */
export const AppProvider = ({ children, startingState = initialState }) => {
  const [state, dispatch] = useReducer(reducer, startingState);

  return (
    <AppContext.Provider value={state}>
      <AppDispatchContext.Provider value={dispatch}>{children}</AppDispatchContext.Provider>
    </AppContext.Provider>
  );
};

/** Hook to access the app context state */
export const useAppContext = () => useContext(AppContext);

/** Hook to access the app context dispatch */
export const useAppDispatch = () => useContext(AppDispatchContext);
